module.exports = __webpack_public_path__ + "img/jacketandtandempants.aca659bb.png";